interface DeviceTableEmptyProps {
	totalCount: number
	filteredCount: number
}

export const DeviceTableEmpty = ({totalCount, filteredCount}: DeviceTableEmptyProps) => {
	if (totalCount === 0) {
		return (
			<div className="text-center py-12 text-gray-500 dark:text-gray-400">
				<div className="text-lg mb-2">No devices found</div>
				<div className="text-sm">No device data available to display</div>
			</div>
		)
	}

	if (filteredCount === 0) {
		return (
			<div className="text-center py-12 text-gray-500 dark:text-gray-400">
				<div className="text-lg mb-2">No devices match the current filter</div>
				<div className="text-sm">Try selecting a different device type filter</div>
			</div>
		)
	}

	return null
}
